import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { Activity, TrendingUp } from 'lucide-react';
import { useGetPublicAnalytics } from '../hooks/useQueries';

export default function PublicAnalyticsDashboard() {
  const { data: analytics, isLoading } = useGetPublicAnalytics();

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-accent/5 to-transparent">
      <div className="container mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold bg-gradient-to-r from-primary via-purple-400 to-primary bg-clip-text text-transparent mb-4">
            Platform Analytics
          </h2>
          <p className="text-muted-foreground text-lg">
            Real-time insights into KawSwap's trading activity
          </p>
        </div>

        {isLoading ? (
          <div className="grid gap-6 md:grid-cols-1 mb-8">
            <Card className="border-2 border-border">
              <CardHeader>
                <Skeleton className="h-6 w-32" />
              </CardHeader>
              <CardContent>
                <Skeleton className="h-12 w-full" />
              </CardContent>
            </Card>
          </div>
        ) : analytics ? (
          <>
            {/* Key Metrics */}
            <div className="grid gap-6 md:grid-cols-1 mb-8">
              <Card className="border-2 border-primary/30 glow-purple">
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                  <CardTitle className="text-sm font-medium">Total Swaps</CardTitle>
                  <Activity className="h-5 w-5 text-primary" />
                </CardHeader>
                <CardContent>
                  <div className="text-3xl font-bold text-primary">
                    {analytics.totalSwapCount.toString()}
                  </div>
                  <p className="text-xs text-muted-foreground mt-2">
                    All-time swap transactions on KawSwap
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* Info Card */}
            <Card className="border-2 border-border">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <TrendingUp className="h-6 w-6 text-primary" />
                  Trading Activity
                </CardTitle>
                <CardDescription>
                  Public analytics showing platform usage
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="bg-accent/30 rounded-lg p-6 text-center">
                  <p className="text-lg font-semibold mb-2">
                    {analytics.totalSwapCount.toString()} Total Swaps
                  </p>
                  <p className="text-sm text-muted-foreground">
                    KawSwap facilitates decentralized trading across multiple blockchains
                  </p>
                  <div className="mt-4">
                    <Badge variant="outline" className="border-primary/50">
                      Live Platform Data
                    </Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          </>
        ) : (
          <div className="text-center py-12">
            <p className="text-muted-foreground">No analytics data available</p>
          </div>
        )}
      </div>
    </section>
  );
}
